import React from 'react';
import ReactDOM from 'react-dom/client';
import { addClassNames } from '../../Functions/Helper/Component';
import processXML from './ProcessXML';
import processNumbering from './processNumbering';
import processStyle from './processStyles';
import LoadingScreen from '../Generic/LoadingSpinner';
/* eslint-disable import/no-webpack-loader-syntax */
import XMLStyle from '!!raw-loader!sass-loader!./XMLView.scss';
/* eslint-enable import/no-webpack-loader-syntax */


export default function XMLView({XML, relations, links, watermark, loading, err}) {
    const [MainXML, numbering, styles] = React.useMemo(() => [
        XML['main.xml'],
        processNumbering(XML['numbering.xml']),
        processStyle(XML['styles.xml'])
    ], [XML]);
    const processProps = React.useMemo(() => ({ numbering, relations, links, styles }), [numbering, relations, links, styles]);
    const {components, context} = React.useMemo(() => processXML(MainXML, processProps), [MainXML, processProps]);

    const headers = React.useMemo(() => {
        if (context.firstHeader && Array.isArray(relations._children)) {
            const headerRelation = relations._children.find(rel => rel._attrs && (rel._attrs['Id'] === context.firstHeader));
            if (headerRelation && headerRelation._attrs['Target'] && XML[headerRelation._attrs['Target']]) {
                const headerFileName = headerRelation._attrs['Target'];
                const { components } = processXML(XML[headerFileName], processProps);
                return components;
            }
        }
        return [];
    }, [context.firstHeader, relations._children, XML, processProps]);
    const docxPreviewRef = React.useRef(null);
    const shadowRootRef = React.useRef(null);
    const rootRef = React.useRef(null);
    const container = React.useMemo(() => {
        const container = document.createElement('div');
        container.className = 'docx-container';
        return container;
    }, []);
    
    React.useEffect(() => {
        if (docxPreviewRef.current) {
            if (!rootRef.current) {
                rootRef.current = ReactDOM.createRoot(container);
            }
            if (!shadowRootRef.current) {
                shadowRootRef.current = docxPreviewRef.current.attachShadow({mode: 'open'});
            }
            const shadowRoot = shadowRootRef.current;
            const root = rootRef.current;
            // Load the XMLView.scss styles into the shadow DOM
            const style = document.createElement('style');
            style.textContent = XMLStyle;
            shadowRoot.appendChild(style);
            shadowRoot.appendChild(container);
            const reactContainer = (
                <div
                 className={addClassNames("docx-preview", context.className)} 
                 style={context.style}
                >
                    {!loading && watermark && (
                        <div className="docx-watermark">
                            <div className='docx-watermark-text'>
                                {watermark}
                            </div>
                        </div>
                    )}
                    <div className="docx-header">
                        {err ? (
                            <div>
                                Error: Please contact Administrator. <a href="mailto:support@mycareerbrand.net">support@mycareerbrand.net</a>
                            </div>
                        ) : !loading && headers.map((comp, key) => <React.Fragment key={key}>{comp}</React.Fragment>)}
                    </div>
                    <div className="docx-body">
                        {loading ? <LoadingScreen /> : components.map((comp, key) => <React.Fragment key={key}>{comp}</React.Fragment>)}
                    </div>
                </div>
            );
            // avoid flashing by delaying rendering for 100ms
            let mounted = true;
            root.renderTimeout = setTimeout(() => {
                if (mounted && root) {
                    root.render(reactContainer);
                }
            }, 300);
            return () => {
                mounted = false;
                shadowRoot.innerHTML = '';      
            };
        }
    }, [context.className, context.style, components, headers, loading, watermark, err, container]);
    React.useEffect(() => () => {
        if (docxPreviewRef.current && rootRef.current) {
            if (rootRef.current?.renderTimeout) {
                clearTimeout(rootRef.current.renderTimeout);   
            }
            rootRef.current.unmount();
            rootRef.current = null;
        }
    }, [])
    return (
        <div ref={docxPreviewRef}/>
    );
}